import React from 'react';
import { Typography } from '@mui/material';

import { HelpPanelTemplate } from './Panel1AHelp';
import useTranslate from '../../../../hooks/useTranslate';

const DashboardHelp = () => {
  const t = useTranslate();
  return (
    <HelpPanelTemplate
      bubbleColor="#edf8f4"
      bubbleTitle={`${t('dashboardHelp-bubbleTitle')}`}
      bubbleContent={`${t('dashboardHelp-bubbleContent')}`}
      url="https://scribehow.com/page/MyJobMatch_User_Guide__MvTvMMEgTnuoLyJSQJJBvg"
    />
  );
};

export default DashboardHelp;

export const ReferenceCodeHelp = () => {
  const t = useTranslate();
  return (
    <HelpPanelTemplate
      bubbleColor="#f8f3ed"
      bubbleTitle={`${t('referenceCodeHelp-bubbleTitle')}`}
      bubbleContent={`${t('referenceCodeHelp-bubbleContent')}`}
      url="https://scribehow.com/shared/Create_Account_with_Reference_Code__cuvhCLvzTZ-d2XetXiIFCw"
    />
  );
};
export const MyProfileHelp = () => {
  const t = useTranslate();
  return (
    <HelpPanelTemplate
      bubbleColor="#f6edf8"
      bubbleTitle={`${t('myProfileHelp-bubbleTitle')}`}
      bubbleContent={`${t('myProfileHelp-bubbleContent')}`}
      url="https://scribehow.com/page/MyJobMatch_User_Guide__MvTvMMEgTnuoLyJSQJJBvg"
    />
  );
};
export const EditProfileHelp = () => {
  const t = useTranslate();
  return (
    <HelpPanelTemplate
      bubbleColor="#f8edf4"
      bubbleTitle={`${t('editProfileHelp-bubbleTitle')}`}
      bubbleContent={`${t('editProfileHelp-bubbleContent')}`}
      url="https://scribehow.com/shared/How_to_Edit_Your_Profile__uBB6vp0RRiyk4fS5t-TwFQ"
    />
  );
};

export const JobsHelp = () => {
  const t = useTranslate();
  const makeFirstPartBold = (text: string) => {
    const parts = text.split(':');
    if (parts.length > 1) {
      return (
        <span>
          <strong>{parts[0]}:</strong>
          {parts.slice(1).join(':')}
        </span>
      );
    }
    return <span>{text}</span>;
  };
  const content = () => (
    <>
      <Typography variant="body1" fontWeight={500} lineHeight={1.5}>
        {t('jobsHelp-bubbleContent')}
      </Typography>
      <br />
      <Typography variant="body1" fontWeight={500} lineHeight={1.5}>
        {t('jobsHelp-bubbleContent-list-title')}
        <ul>
          <li>{makeFirstPartBold(t('jobsHelp-bubbleContent-list-item1'))}</li>
          <li>{makeFirstPartBold(t('jobsHelp-bubbleContent-list-item2'))}</li>
        </ul>
      </Typography>
    </>
  );

  return (
    <HelpPanelTemplate
      bubbleColor="#f8eded"
      bubbleTitle={`${t('jobsHelp-bubbleTitle')}`}
      bubbleContent={content()}
      url="https://scribehow.com/shared/How_to_Browse_Filter_and_Sort_Jobs__OyZj8_E-RU6n-CWT2nqDIg"
    />
  );
};
export const JobMatchesHelp = () => {
  const t = useTranslate();
  return (
    <HelpPanelTemplate
      bubbleColor="#edf1f8"
      bubbleTitle={`${t('jobMatchesHelp-bubbleTitle')}`}
      bubbleContent={`${t('jobMatchesHelp-bubbleContent')}`}
      url="https://scribehow.com/shared/How_to_Browse_Your_Job_Matches__Lze1nhItQzWryI8iyyJ1bQ"
    />
  );
};

export const ActivityHelp = () => {
  const t = useTranslate();
  return (
    <HelpPanelTemplate
      bubbleColor="#f6f8ed"
      bubbleTitle={`${t('myActivityHelp-bubbleTitle')}`}
      bubbleContent={`${t('myActivityHelp-bubbleContent')}`}
      url=""
    />
  );
};

export const ChatHelp = () => {
  const t = useTranslate();
  return (
    <HelpPanelTemplate
      bubbleColor="#F0F8FF"
      bubbleTitle={`${t('chatHelp-bubbleTitle')}`}
      bubbleContent={`${t('chatHelp-bubbleContent')}`}
      url=""
    />
  );
};
